import { render } from "./EditGroupModal.vue?vue&type=template&id=7ff7fa6a"
import script from "./EditGroupModal.vue?vue&type=script&setup=true&lang=js"
export * from "./EditGroupModal.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/ui/PlatformList/EditGroupModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7ff7fa6a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7ff7fa6a', __exports__)) {
    api.reload('7ff7fa6a', __exports__)
  }
  
  module.hot.accept("./EditGroupModal.vue?vue&type=template&id=7ff7fa6a", () => {
    api.rerender('7ff7fa6a', render)
  })

}


export default __exports__